export default __webpack_public_path__ + "static/media/general-template-image.f24284ed.svg";